<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <h2>Dettaglio sala</h2>
    <div fxLayout="column" class="responsive-mat-form">
      <form [formGroup]="form" fxLayout="column">
        <!-- Id field -->
        <mat-form-field>
          <input matInput formControlName="id" placeholder="Saletta Id" readonly="true" />
        </mat-form-field>

        <!-- Sede field -->
        <mat-form-field fxLayout="column">
          <mat-label>Sedi</mat-label>
          <mat-select formControlName="sede" [compareWith]="compareDTO"
            [disabled]="!isJappTenantAdmin()">
            <mat-option *ngFor="let sede of sedi" [value]="sede">
              {{sede.descrizione}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('sede').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>


        <!-- Descrizione field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="descrizione" placeholder="Saletta Description" />
          <mat-error *ngIf="form.get('descrizione').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!-- Campi di informazione operazione -->
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Dettagli operazione
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="row">
            <!-- InsertDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="insertDate" placeholder="Insert Date" readonly="true" />
            </mat-form-field>

            <!-- InsertUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="insertUser" placeholder="Insert User" readonly="true" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <!-- UpdateDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="updateDate" placeholder="Update Date" readonly="true" />
            </mat-form-field>

            <!-- UpdateUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="updateUser" placeholder="Update User" readonly="true" />
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
    <mat-card-actions>
      <button mat-raised-button (click)="backConfirm('/saletta')" color="primary">Back</button>
      <button mat-raised-button (click)="salettaSave()" [disabled]="form.invalid || !form.dirty"
        *ngIf="saletta?.deleteDate==null">Save</button>
      <button mat-raised-button (click)="salettaDelete()" [disabled]="saletta?.id==null"
        *ngIf="saletta?.deleteDate==null">Delete</button>
    </mat-card-actions>
  </mat-card-content>
</mat-card>